import { Helmet } from 'react-helmet-async';
import Header from './Header';
import { useTranslation } from 'react-i18next';

type PageWrapperProps = {
  children?: React.ReactNode;
  title: string;
  subtitle?: {
    key: string;
    options?: Record<string, any>;
  };
};

const PageWrapper = ({ children, title, subtitle }: PageWrapperProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>
      <div className='h-100 w-100 d-flex flex-column'>
        <Header title={t(title)} subtitle={subtitle ? t(subtitle.key, subtitle.options) : ''} />
        {children}
      </div>
    </>
  );
};

export default PageWrapper;
